module.exports = __webpack_public_path__ + "static/media/i-14.cbf40601.svg";